<template>
    <div v-if="items && items.length > 0">
        <div style="position: relative; right: 4px; top: 4px; height: 0px">
            <BaseButton
                @click="openAllLocationsDialog"
                style="float: right"
                variant="outline-primary"
                tiny
                >{{ $t('companyDetail.locations.viewAll') }}</BaseButton
            >
        </div>
        <Paper
            class="locations-root"
            :header="$t('companyDetail.locations.header')"
        >
            <Carousel
                v-if="items"
                :items="items.slice(0, 10)"
                :noResourcesMessage="$t('companyDetail.locations.noLocations')"
            />
            <div v-else style="padding-bottom: 20px">
                <LocationSkeleton />
            </div>
        </Paper>
    </div>
</template>

<script>
import DialogService from '~/services/DialogService';
import Spinner from '~/components/builders/Spinner';
import LocationSkeleton from './skeletons/LocationSkeleton';

export default {
    name: 'Locations',
    components: { Spinner, LocationSkeleton },
    methods: {
        openAllLocationsDialog() {
            DialogService.openAllLocationsDialog({ items: this.items });
        },
    },
    props: {
        items: Array,
    },
};
</script>

<style lang="css" scoped></style>
